export { default } from './components/KitInternationalPhoneNumberInput';
